<template>
  <div class="notifications-panel">
    <div class="header">
      <TextBody tag="span" i18n-key="notifications.notifications" weight="medium" :body-type="2"></TextBody>
      <BbBtn v-if="notifications.length > 0" class="delete-all-button" size="small" type="tertiary" @click="clearAll">
        <TextBody i18n-key="common.clearAll"></TextBody>
      </BbBtn>
    </div>
    <div v-if="notifications.length === 0" class="empty-message">
      <TextBody tag="span" i18n-key="notifications.noNewNotifications" weight="medium" :body-type="2"></TextBody>
      <TextBody tag="span" i18n-key="notifications.notificationsAppearHere" :body-type="2"></TextBody>
    </div>
    <div class="notifications-list">
      <NotificationCard v-for="notification in notifications" :key="notification.id" :notification="notification" />
    </div>
  </div>
</template>

<script>
import useNotifications from '~/composables/useNotifications';
import TextBody from '~/components/common/TextBody';
import NotificationCard from '~/components/conversation/notificationsPanel/NotificationCard';
import { onMounted } from 'vue';

export default {
  components: { NotificationCard, TextBody },
  setup() {
    const { notifications, markAllAsRead, removeAllNotifications, removeAllToasts } = useNotifications();

    const clearAll = () => {
      removeAllNotifications();
      removeAllToasts();
    };

    onMounted(() => {
      const notificationIds = notifications.value.filter(({ readAt }) => !readAt).map(({ id }) => id);

      if (notificationIds?.length) {
        markAllAsRead(notificationIds);
      }
    });

    return {
      notifications,
      clearAll,
    };
  },
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}

.notifications-panel {
  @include media-breakpoint-up('sm') {
    display: flex;
  }

  max-height: calc(100vh - 80px);

  // take into consideration the margins
  height: 100%;
  display: none;
  flex-direction: column;
  background-color: $bb-neutral-6;
  border-radius: $bb-spacing-8;
  border: 1px solid #cecdcb;
  box-shadow: 0 0 $bb-spacing-2 0 #0000001a;
  align-items: flex-start;
  min-width: 348px;
  max-width: 348px;
  padding: $bb-spacing-4 0 $bb-spacing-4 0;
  overflow: auto;

  .empty-message {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    justify-content: center;
    align-self: center;

    :deep(span:first-of-type) {
      font-size: $bb-spacing-6;
      line-height: $bb-spacing-7;
    }
  }

  .header {
    padding: 0 $bb-spacing-4 0 $bb-spacing-4;

    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    gap: $bb-spacing-2;
    margin-bottom: $bb-spacing-6;

    .delete-all-button {
      margin-left: auto;
    }

    .close-button {
      margin-left: auto; /* This pushes the third item (button) to the end of the flex container */
    }
  }

  .notifications-list {
    display: flex;
    flex-direction: column;
    gap: $bb-spacing-4;
    width: 100%;
    padding: $bb-spacing-4;
  }
}
</style>
